import { getOSInfo, isApp } from "@akina/utils";

export async function getAuthOS() {
  if (!isApp) return "web";
  const os = await getOSInfo();
  if (os === "windows") return "windows";
  else return "macos";
}
